import { Tag } from '@omnipresentgroup/design-system';

const DetailsCardRedactedType = () => (
  <Tag id="details-card-redacted-type" intent="default">
    REDACTED
  </Tag>
);

export default DetailsCardRedactedType;
